import TermAccordion from '@components/term/TermAccordion';
import styled from '@emotion/styled';
import useTermCategories from '@hooks/term/useTermCategories';

interface Props {

}

function PrepaidCardNotes() {
    const termCategories = useTermCategories('PREPAY');
    return (
        <Container>
            {termCategories.map((termCategory) => (
                <TermAccordion termCategory={termCategory}
                    key={termCategory.id}/>
            ))}
        </Container>
    );
}

const Container = styled.footer`
    margin-bottom: 48px;
    width: 100%;
`;

export default PrepaidCardNotes;
